import { PieChart, Pie, Cell, Legend, ResponsiveContainer } from "recharts";

const defaultData = [
  { name: "Present", value: 0, color: "#22c55e" },
  { name: "Absent", value: 0, color: "#ef4444" },
  { name: "Leave", value: 0, color: "#3b82f6" },
];

export default function AttendanceOverview({ data, isStaff = false }) {
  // Map API data to attendance chart based on actual API response structure
  let chartData = defaultData;
  let total = 0;

  if (isStaff && data?.attendance) {
    // Staff dashboard structure - use attendance object
    const attendance = data.attendance;
    const presentCount = attendance.present_count || 0;
    const absentCount = attendance.absent_count || 0;
    const leaveCount = attendance.leave_count || 0;
    total = attendance.total_count || 0;

    chartData = [
      { name: "Present", value: presentCount, color: "#22c55e" },
      { name: "Absent", value: absentCount, color: "#ef4444" },
      { name: "Leave", value: leaveCount, color: "#3b82f6" },
    ];
  } else if (data?.todayAttendance) {
    // Admin dashboard structure
    chartData = [
      { name: "Present", value: data.todayAttendance.present_count || 0, color: "#22c55e" },
      { name: "Absent", value: data.todayAttendance.absent_count || 0, color: "#ef4444" },
      { name: "Leave", value: data.todayAttendance.leave_count || 0, color: "#3b82f6" },
    ];
    total = chartData.reduce((sum, item) => sum + item.value, 0);
  } else {
    total = chartData.reduce((sum, item) => sum + item.value, 0);
  }

  return (
    <div className="bg-white p-5 rounded-xl border border-borderColor">
      <h3 className="font-semibold text-gray-900 mb-3">Attendance Overview</h3>

      {/* Display numbers */}
      <div className="flex justify-center gap-4 mb-3 text-xs">
        {chartData.map((entry, index) => (
          <div key={index} className="flex items-center gap-1.5">
            <span
              className="w-2.5 h-2.5 rounded-full"
              style={{ backgroundColor: entry.color }}
            ></span>
            <span className="text-gray-500">
              {entry.name}: <span className="font-semibold text-gray-700">{entry.value}</span>
            </span>
          </div>
        ))}
      </div>

      <ResponsiveContainer width="100%" height={250}>
        <PieChart>
          <Pie
            data={chartData}
            cx="50%"
            cy="50%"
            innerRadius={60}
            outerRadius={90}
            paddingAngle={5}
            dataKey="value"
          >
            {chartData.map((entry, index) => (
              <Cell key={index} fill={entry.color} />
            ))}
          </Pie>
          <Legend />
        </PieChart>
      </ResponsiveContainer>

      <div className="text-center mt-2">
        <p className="text-gray-400 text-xs">
          {isStaff ? (
            <>Total Days: <span className="font-semibold text-gray-600">{total}</span></>
          ) : (
            <>Total: <span className="font-semibold text-gray-600">{total}</span></>
          )}
        </p>
      </div>
    </div>
  );
}
